<ms-event-pick
    class="six-pack-option-selectable"
    [class.offline]="!option.online"
    [class.highlight]="isHighlighted"
    [option]="option"
    [event]="event"
    [optionGroup]="optionGroup"
    [trackingPosition]="trackingPosition"
    [isAutomatedMarquee]="isAutomatedMarquee">
    @if (!option.online) {
        <vn-icon name="theme-locked-i" size="16"></vn-icon>
    } @else {
        @if (showAttributeValue) {
            <div
                class="option-attribute"
                [class.small-font]="attributeValue?.length > 6"
                [class.option-group-attribute]="optionGroup.categoryAttribute">
                {{ attributeValue }}
            </div>
        }
        <div class="option option-value">
            <ms-font-resizer defaultSize="1" maxChars="6" [value]="option.nativePrice | msNativePriceFormatter"></ms-font-resizer>
        </div>
    }
</ms-event-pick>
